import { render, staticRenderFns } from "./ThemplateMedicalRecord.vue?vue&type=template&id=cbab8f9e&scoped=true"
import script from "./ThemplateMedicalRecord.vue?vue&type=script&lang=js"
export * from "./ThemplateMedicalRecord.vue?vue&type=script&lang=js"
import style0 from "./ThemplateMedicalRecord.vue?vue&type=style&index=0&id=cbab8f9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbab8f9e",
  null
  
)

export default component.exports